import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Modal, message } from 'ant-design-vue'
import { reactive } from 'vue'
export function delData<P = any, R = any>(
  api: ((params: P) => Promise<R>) | ((params: P) => R),
  params: Parameters<typeof api>[0],
  name = '',
  title = '删除'
) {
  return new Promise((resolve, reject) => {
    const okButtonProps = reactive({ loading: false, danger: true })
    const cancelButtonProps = reactive({ disabled: false })
    const content = `确认${title}${name}？请确认您了解此操作的风险。`
    const toggleLoading = () => {
      okButtonProps.loading = !okButtonProps.loading
      cancelButtonProps.disabled = !cancelButtonProps.disabled
    }
    Modal.confirm({
      title: `确认${title}？`,
      icon: <ExclamationCircleOutlined />,
      content,
      centered: true,
      keyboard: false,
      okButtonProps,
      cancelButtonProps,
      async onOk() {
        toggleLoading()
        try {
          await api(params)
          message.success(`${title}成功`)
          resolve(true)
          return Promise.resolve()
        } catch (err) {
          message.error(`${title}失败`)
          reject(err)
          return Promise.reject(err)
        } finally {
          toggleLoading()
        }
      }
    })
  })
}
